export default __webpack_public_path__ + "static/featured-eb522499abd90a184729bb054a4f96ea.png";